module.exports = __webpack_public_path__ + "img/012-wizard.8ee493fe.png";